export const forgot_password = {
  forgot_password: "Réinitialiser mot de passe",
  confirm: "Confirmer",
  mail_sended: "Vous allez recevoir un email",
  user_not_found: "Utilisateur non trouvé !",
  email_place_holder: "Veuillez saisir votre email.",
};
